module.exports = __webpack_public_path__ + "img/冲压车间2.211de0eb.jpg";